import React, {useMemo} from "react";
import {Menu, MenuProps} from "antd";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {RootState} from "../../../reducers/reducer";
import {PERM_MASTER, PERM_SORTING, PERM_UNIT} from "../../../common/consts.common";
import menuData from "../../../datas/menu.data.json";
import menuhubData from "../../../datas/menuhub.data.json";

type MenuItem = Required<MenuProps>['items'][number];
const SideMenu = () => {
  const navigate = useNavigate();
  const {permission_group} = useSelector((state: RootState) => state.profile);
  
  const menuItems: MenuItem[] = useMemo(() => {
    return permission_group && (permission_group.includes(PERM_MASTER) || permission_group.includes(PERM_SORTING))
      ? menuData
      : permission_group && permission_group.includes(PERM_UNIT) ? [] : menuhubData;
  }, [permission_group]);
  
  const handleSelect = (menuItem: any) => {
    console.log("handleSelect menuItem", menuItem);
    if (!!menuItem.key) {
      navigate(menuItem.key);
    }
    else {
      navigate("/home");
    }
  };
  
  return (<Menu
    onClick={handleSelect}
    // style={{width: SIDE_MENU_WIDTH, paddingTop: 11}}
    theme={"dark"}
    className={"w-[var(--side-menu-width)]"}
    mode={"inline"}
    items={menuItems}
    defaultOpenKeys={["main", "status"]}
  />);
};

export default SideMenu;
